import {useEffect, useRef} from 'react'

import {getCalApi} from '@calcom/embed-react'

import {REACT_APP_CALCOM_EMBED_URL} from '@progyny/utils/env'

export function useCalEvent(
  namespace: string,
  action: string,
  callback: () => void,
  enabled = true
) {
  const callbackRef = useRef(callback)
  callbackRef.current = callback

  useEffect(() => {
    if (!enabled) {
      return
    }

    let cancelled = false
    let cleanup: (() => void) | undefined

    const handler = () => callbackRef.current()

    ;(async function () {
      try {
        const cal = await getCalApi({
          namespace,
          embedJsUrl: REACT_APP_CALCOM_EMBED_URL,
        })

        if (cancelled) {
          return
        }

        const calAction = action as 'bookingCancelled'
        cal('on', {action: calAction, callback: handler})
        cleanup = () => cal('off', {action: calAction, callback: handler})
      } catch (error) {
        console.error('Cal.com embed initialization error:', error) // eslint-disable-line no-console
      }
    })()

    return () => {
      cancelled = true
      cleanup?.()
    }
  }, [namespace, action, enabled])
}
